import { all, fork } from 'redux-saga/effects'

// core
import config from '@redux/saga/core/config.saga'
import auth from '@redux/saga/core/auth.saga'
import route from '@redux/saga/core/route.saga'
import user from '@redux/saga/core/user.saga'
import i18n from '@redux/saga/core/i18n.saga'
import grid from '@redux/saga/core/grid.saga'
import main from '@redux/saga/core/main.saga'
// @PLOP-IMPORTS

export default function* rootSaga() {
	yield all([
		fork(config),
		fork(auth),
		fork(route),
		fork(user),
		fork(i18n),
		fork(grid),
		fork(main),
		// @PLOP-CODE
	])
}
